import {
  selectAudioTrackByPeerID,
  selectLocalPeerID,
  selectPeerNameByID,
  selectVideoTrackByID,
  selectVideoTrackByPeerID,
  useHMSStore,
} from "@100mslive/react-sdk";
import {
  StyledVideoTile,
  Text,
  textEllipsis,
  useBorderAudioLevel,
  Video,
} from "@100mslive/roomkit-react";
import { Avatar } from "antd";
import { getUserInfo } from "@/reducers/commonSlice";
import { useSelector } from "react-redux";
import { useEffect } from "react";

function Peer({ peer, setLocalPeerId }) {
  // const { videoRef } = useVideo({
  //   trackId: peer.videoTrack,
  // });
  // console.log(peer);
  // const metaData = useHMSStore(selectPeerMetadata(peer.id));
  // console.log(metaData);
  const userData = useSelector(getUserInfo);

  const trackSelector = peer.trackId
    ? selectVideoTrackByID(peer.trackId)
    : selectVideoTrackByPeerID(peer.id);
  const track = useHMSStore(trackSelector);
  const peerName = useHMSStore(selectPeerNameByID(peer.id));
  const audioTrack = useHMSStore(selectAudioTrackByPeerID(peer.id));
  const borderAudioRef = useBorderAudioLevel(audioTrack?.id);
  const isVideoMuted = !track?.enabled;
  const isVideoDegraded = track?.degraded;
  const localPeerID = useHMSStore(selectLocalPeerID);
  const isLocal = localPeerID === peer.id;
  const userProfileImg = isLocal
    ? userData.profileImgUrl
      ? userData.profileImgUrl
      : "/assets/images/defaultProfile.jpeg"
    : "/assets/images/defaultProfile.jpeg";

  useEffect(() => {
    setLocalPeerId(localPeerID);
  }, [localPeerID]);

  return (
    <div className="peer-container">
      <Video
        ref={borderAudioRef}
        trackId={peer.videoTrack}
        degraded={isVideoDegraded}
        className={`w-100 peer-video ${isLocal ? "local" : ""}`}
        data-testid="participant_video_tile"
      />
      {/* <video
        ref={videoRef}
        className={`w-100 peer-video ${isLocal ? "local" : ""}`}
        autoPlay
        muted
        playsInline
      /> */}
      {isVideoMuted || isVideoDegraded ? (
        <StyledVideoTile.AvatarContainer>
          <Avatar name={peerName || ""} data-testid="participant_avatar_icon" size={"large"}>
            <img src={userProfileImg} height={"100%"} width={"100%"} alt="profile" />
          </Avatar>
          <Text css={{ ...textEllipsis("75%") }} variant="body2">
            {peerName}
          </Text>
        </StyledVideoTile.AvatarContainer>
      ) : null}
      {/* <div className="peer-name">
        {peer.name} {peer.isLocal ? "(You)" : ""}
      </div> */}
    </div>
  );
}

export default Peer;
